import { FlexCol, FlexRow } from '@/components/ui/flex';
import { Text } from '@/components/ui/text';
import { cn } from '@/utils/classUtils';
import { MessageAttachment } from '@ditto/shared';
import { File, FileText, Image } from 'lucide-react';
import { type FC } from 'react';

interface MessageAttachmentProps {
  attachment: MessageAttachment;
  className?: string;
}

const getFileIcon = (mimeType: string) => {
  if (mimeType.startsWith('image/')) {
    return <Image className="w-4 h-4" />;
  }
  if (mimeType === 'application/pdf') {
    return <FileText className="w-4 h-4" />;
  }
  return <File className="w-4 h-4" />;
};

const getFileTypeColor = (mimeType: string) => {
  if (mimeType === 'application/pdf') {
    return 'bg-red-500';
  }
  if (mimeType.startsWith('image/')) {
    return 'bg-blue-500';
  }
  return 'bg-gray-500';
};

export const MessageAttachmentComponent: FC<MessageAttachmentProps> = ({
  attachment,
  className,
}) => {
  return (
    <FlexRow
      alignItems="center"
      gap="2"
      p="2"
      br="md"
      className={cn(
        'bg-gray-50 border border-gray-200 hover:bg-gray-100 transition-colors max-w-[300px]',
        className
      )}
    >
      <FlexRow
        alignItems="center"
        justifyContent="center"
        className={cn(
          'w-8 h-8 rounded text-white',
          getFileTypeColor(attachment.mimeType)
        )}
      >
        {getFileIcon(attachment.mimeType)}
      </FlexRow>
      <FlexCol gap="0.5" className="flex-1 min-w-0">
        <Text
          variant="body-sm"
          color="primary"
          className="font-medium truncate"
        >
          {attachment.name}
        </Text>
        <FlexRow alignItems="center" gap="2">
          <Text
            variant="body-xs"
            color="secondary"
            className="uppercase truncate"
          >
            {attachment.mimeType.split('/')[1] || 'FILE'}
          </Text>
        </FlexRow>
      </FlexCol>
    </FlexRow>
  );
};
